import { render, staticRenderFns } from "./favorite_list.vue?vue&type=template&id=7968a56c&scoped=true&"
import script from "./favorite_list.vue?vue&type=script&lang=js&"
export * from "./favorite_list.vue?vue&type=script&lang=js&"
import style0 from "./favorite_list.vue?vue&type=style&index=0&id=7968a56c&scoped=true&lang=css&"
import style1 from "./favorite_list.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7968a56c",
  null
  
)

export default component.exports